import { getConsent, onConsentChange } from './consent';

let allPagesInjected = false;
let receiptInjected = false;

/**
 * Inject `custom_tracking_allpages` HTML/script content.
 * Gated behind statistics consent.
 */
export function injectCustomTrackingAllPages(html: string | null): void {
  if (allPagesInjected || !html) return;

  const consent = getConsent();
  if (consent?.statistics) {
    doInject(html, 'custom-tracking-allpages');
    allPagesInjected = true;
  } else {
    const unsub = onConsentChange((prefs) => {
      if (prefs.statistics && !allPagesInjected && html) {
        doInject(html, 'custom-tracking-allpages');
        allPagesInjected = true;
        unsub();
      }
    });
  }
}

/**
 * Inject `custom_tracking_receipt` HTML/script content.
 * Gated behind statistics consent. Should only be called on the receipt page.
 */
export function injectCustomTrackingReceipt(html: string | null): void {
  if (receiptInjected || !html) return;

  const consent = getConsent();
  if (consent?.statistics) {
    doInject(html, 'custom-tracking-receipt');
    receiptInjected = true;
  } else {
    const unsub = onConsentChange((prefs) => {
      if (prefs.statistics && !receiptInjected && html) {
        doInject(html, 'custom-tracking-receipt');
        receiptInjected = true;
        unsub();
      }
    });
  }
}

/**
 * Parse and inject HTML content that may contain script tags.
 */
function doInject(html: string, id: string): void {
  const container = document.createElement('div');
  container.setAttribute('data-analytics', id);
  container.style.display = 'none';
  container.innerHTML = html;

  // Extract and re-create script tags so they actually execute
  const scripts = container.querySelectorAll('script');
  const fragment = document.createDocumentFragment();

  scripts.forEach((originalScript) => {
    const newScript = document.createElement('script');
    // Copy attributes
    for (const attr of Array.from(originalScript.attributes)) {
      newScript.setAttribute(attr.name, attr.value);
    }
    if (originalScript.textContent) {
      newScript.textContent = originalScript.textContent;
    }
    originalScript.remove();
    fragment.appendChild(newScript);
  });

  document.head.appendChild(container);
  document.head.appendChild(fragment);
}
